import { DOC_FLOW_ENTITY } from '../constants/entity'
import { getApi } from '../utils/api'

export function getDocFlowProfile(id) {
  return getApi({
    endpoint: `/api/${DOC_FLOW_ENTITY.single}/${DOC_FLOW_ENTITY.plural}/${id}/`,
  })
}
